const colorPresets = [
	{
		presetName: "preset1",
		primaryColor: "#FC3B3D",
		secondaryColor: "#003D73"
	},
	{
		presetName: "preset2",
		primaryColor: "#00CCD5",
		secondaryColor: "#860058"
	},
	{
		presetName: "preset3",
		primaryColor: "#8700D7",
		secondaryColor: "#FF8467"
	},
	{
		presetName: "preset4",
		primaryColor: "#3B908B",
		secondaryColor: "#FFDA33"
	},
	{
		presetName: "preset5",
		primaryColor: "#001DBD",
		secondaryColor: "#EAE1D5"
	},
	{
		presetName: "preset6",
		primaryColor: "#f3bebf",
		secondaryColor: "#0a4171"
	}
];

export default colorPresets;
